var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9163 15.3026L25.833 13.1499V18.6861C25.0684 18.3013 24.1838 18.0834 23.2497 18.0834C20.443 18.0834 18.083 20.0501 18.083 22.6043C18.083 25.1585 20.443 27.1251 23.2497 27.1251C26.0564 27.1251 28.4163 25.1585 28.4163 22.6043V2.35034L10.333 5.36423V19.9778C9.5684 19.5929 8.68378 19.3751 7.74967 19.3751C4.94299 19.3751 2.58301 21.3417 2.58301 23.8959C2.58301 26.4501 4.94299 28.4168 7.74967 28.4168C10.5564 28.4168 12.9163 26.4501 12.9163 23.8959V15.3026ZM10.333 23.8959C10.333 24.9086 9.22319 25.8334 7.74967 25.8334C6.27616 25.8334 5.16634 24.9086 5.16634 23.8959C5.16634 22.8833 6.27616 21.9584 7.74967 21.9584C9.22319 21.9584 10.333 22.8833 10.333 23.8959ZM23.2497 24.5418C24.7232 24.5418 25.833 23.6169 25.833 22.6043C25.833 21.5916 24.7232 20.6668 23.2497 20.6668C21.7762 20.6668 20.6663 21.5916 20.6663 22.6043C20.6663 23.6169 21.7762 24.5418 23.2497 24.5418ZM12.9163 12.6837V7.55264L25.833 5.39986V10.5309L12.9163 12.6837Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music-note.5ab43f3f.svg";
export { ForwardRef as ReactComponent };